import { render, staticRenderFns } from "./DashboardForAffiliate.vue?vue&type=template&id=5d0e58ed&scoped=true"
import script from "./DashboardForAffiliate.vue?vue&type=script&lang=js"
export * from "./DashboardForAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e58ed",
  null
  
)

export default component.exports